const PHONE_NUMBER_EXCLUDED_SYMBOLS_REGEXP = "[\\s\\-\\_\\#\\(\\)]+";

function clearPhoneNumber(number: string) {
    return number.replace(new RegExp(PHONE_NUMBER_EXCLUDED_SYMBOLS_REGEXP, "g"), "");
}

export default clearPhoneNumber;
